import React, { useRef, useState } from "react";
import classes from "./WithdrawalReceipt.module.css";
import { ToWords } from "to-words";
import Logo from '../../../Assets/Promix.svg';
import html2canvas from "html2canvas";
import { Spinner } from "react-bootstrap";

function WithdrawalReceipt({ isOpen, onClose, data }) {
  const receiptRef = useRef(null);
  const [printing, setPrinting] = useState(false);
  if (!isOpen) return null;

  const amount = Number(data?.amount) || 0;

  const toWords = new ToWords({
    localeCode: "en-US",
    converterOptions: {
      currency: true,
      currencyOptions: {
        name: data?.currency?.currency || "Naira",
        plural: data?.currency?.currency || "Naira",
        symbol: data?.currency?.symbol || "₦",
        fractionalUnit: {
          name: data?.currency?.fraction || "kobo",
          plural: data?.currency?.fraction || "kobo",
          symbol: "",
        },
      },
    },
  });

  let amountInWords = "";
  try {
    amountInWords = toWords.convert(amount);
  } catch {
    amountInWords = "";
  }

  const formattedDate = data?.transactionDate
    ? new Date(data.transactionDate).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  const printedAt = new Date().toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const handlePrint = async () => {
  setPrinting(true);
  if (!receiptRef.current) return;


  try {
    const canvas = await html2canvas(receiptRef.current, {
      scale: 3,
      useCORS: true,
      backgroundColor: "#fff",
    });

    const image = canvas.toDataURL("image/png");

    const printWindow = window.open("", "_blank", "width=500,height=900");

    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <title>Members Savings Slip</title>
        <style>
          body{
            margin:20px;
            display:flex;
            justify-content:center;
            background:#fff;
          }

          img{
            width:320px;
            height:auto;
          }
        </style>
      </head>

      <body>
        <img src="${image}" />
      </body>
      </html>
    `);

    printWindow.document.close();

    printWindow.onload = () => {
      setPrinting(false);

      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  } catch (err) {
    setPrinting(false);
    console.error(err);
  }
};

  return (
    <div className={classes.overlay}>
      <div className={classes.receiptWrapper}>
        <div id="printable-receipt" ref={receiptRef} className={classes.receipt}>
          <div className={classes.brand}>
            <img src={Logo} alt="Promix Logo" className={classes.logo} />
            {/* <p className={classes.brandName}>PROMIX</p> */}
            <p className={classes.brandSub}>MEMBERS' SAVINGS SLIP</p>
          </div>

          <div className={classes.dashedLine} />

          <div className={classes.statusRow}>
            <div className={classes.statusBlock}>

            <span className={classes.statusDot} />
            <span style={{color: '#059669', fontSize: 11, fontWeight: 500, marginLeft: 5}}>{(data?.status || "SUCCESSFUL").toUpperCase()}</span>
            </div>
          </div>

          <div className={classes.amountBlock}>
            <p className={classes.amountLabel}>AMOUNT SAVED</p>
            <p className={classes.amountValue}>
              {data?.currency?.symbol || "₦"}
              {amount.toLocaleString()}
            </p>
            {amountInWords && (
              <p className={classes.amountWords}>{amountInWords}</p>
            )}
          </div>

          <div className={classes.dashedLine} />

          <div className={classes.lineItems}>
            <div className={classes.lineItem}>
              <span>Member Name</span>
              <span>{data?.memberName || "-"}</span>
            </div>
            <div className={classes.lineItem}>
              <span>Reference No.</span>
              <span>{data?.reference || "-"}</span>
            </div>
            <div className={classes.lineItem}>
              <span>Date</span>
              <span>{formattedDate || "-"}</span>
            </div>
            <div className={classes.lineItem}>
              <span>Description</span>
              <span>{data?.description || "-"}</span>
            </div>
          </div>

          <div className={classes.dashedLine} />

          <p className={classes.footerNote}>Thank you for saving with us</p>
          <p className={classes.printedAt}>Printed: {printedAt}</p>

          <div className={classes.zigzag} />
        </div>

        <div className={classes.buttons}>
          <button
    className={classes.printBtn}
    onClick={handlePrint}
    disabled={printing}
>
    {printing ? (
        <>
            <Spinner
                animation="border"
                size="sm"
                style={{ marginRight: 8 }}
            />
            Preparing...
        </>
    ) : (
        "Print"
    )}
</button>
          <button className={classes.closeBtn} onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default WithdrawalReceipt;